import { render } from "./single-widget.vue?vue&type=template&id=3d153003&scoped=true"
import script from "./single-widget.vue?vue&type=script&lang=ts"
export * from "./single-widget.vue?vue&type=script&lang=ts"

import "./single-widget.vue?vue&type=style&index=0&id=3d153003&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d153003"

export default script